import { render, staticRenderFns } from "./BaseButtonToggleable.vue?vue&type=template&id=32988048&scoped=true&"
import script from "./BaseButtonToggleable.vue?vue&type=script&lang=js&"
export * from "./BaseButtonToggleable.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonToggleable.vue?vue&type=style&index=0&id=32988048&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32988048",
  null
  
)

export default component.exports